'use strict';
angular.module('common.filters').filter('iban', function () {
  'use strict';
  return function (input) {
    return input.match(/.{1,4}/g).join(' ');
  };
});
